const invertedMessages = {
  'Set Up ID Proofing Today to Boost Security': 'external.idpSetup.title',
  'explanation etc. Onboarding employees. verification of identity':
    'external.idpSetup.subTitle',
  'Choose a provider': 'external.idpSetup.chooseProvider',
  'Set Up': 'external.idpSetup.setUpBtn',
};

export default invertedMessages;
